import { render } from "./InjuryHeatMap.vue?vue&type=template&id=af4d38ca&scoped=true"
import script from "./InjuryHeatMap.vue?vue&type=script&lang=js"
export * from "./InjuryHeatMap.vue?vue&type=script&lang=js"

import "./InjuryHeatMap.vue?vue&type=style&index=0&id=af4d38ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af4d38ca"]])

export default __exports__